const defaultCourseIds: number[] = [
  39,
  49,
  50,
  51,
  53,
  55,
  56,
  62,
  82,
  103,
  122,
  124,
  125,
  139,
  159,
  162,
  172,
  174,
  177,
  183,
  185,
  194,
  219,
  223,
  230,
  243,
  257,
  276,
  277,
  279,
  282,
  287,
  302,
  320,
  324,
  326,
  328,
  329,
  332,
  336,
  337,
  338,
  344,
  345,
  346,
  349,
  360,
  364,
  373,
  377,
  313,
  237,
  311,
  133,
  139,
  140,
  160,
  171,
  196,
  201,
  216,
  228,
  197,
  200,
  213,
  218,
  288,
  327,
  339,
  318,
  137,
  316,
  312,
  305,
  304,
  386,
  317,
  38,
  303,
  73
]
const defaultRecommendedCourseIds: number[] = [62, 171, 172, 56, 174, 337, 122]
const defaultNewCourseIds: number[] = [377, 386, 177, 364, 327]
const defaultTopSaleCourseIds: number[] = [277, 174, 172, 73, 257, 53, 171]
const defaultSpecialCourseId = 388 // Id course on PROD
const defaultSpecialStartDate = 1763586000000 // 20.11.25 00:00:00
const defaultSpecialCourseIdInSubscription = 306 // Id course on PROD in subscription
const defaultSpecialCourseIdsBundle = [62, 171, 172, 277] // Ids course on PROD bundle
const defaultSpecialCourseIdForClub = 188 // Id course on PROD for club
const defaultSpecialClubId = 1 // Id club on PROD
const defaultPaywallServiceId = 3012 // Id service on PROD in paywall

export {
  defaultCourseIds,
  defaultRecommendedCourseIds,
  defaultNewCourseIds,
  defaultTopSaleCourseIds,
  defaultSpecialCourseId,
  defaultSpecialStartDate,
  defaultSpecialCourseIdInSubscription,
  defaultSpecialCourseIdsBundle,
  defaultSpecialCourseIdForClub,
  defaultSpecialClubId,
  defaultPaywallServiceId
}
